import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;

  width: 100vw;
  height: 100vh;

  section {
    padding: 5rem;

    &:first-of-type {
      border-right: 1px solid #3D3D3D;

      display: flex;
      flex-direction: column;
      justify-content: center;

      h1 {
        font-size: 2.2rem;
      }
    }

    &:last-of-type {
      padding: 5rem;
      height: 100%;
      overflow-y: scroll;

      background-color: var(--black-200);
    }
  }
`

export const HelpHeader = styled.div`
  img {
    width: 200px;
    height: 200px;

    object-fit: contain;
  }
`

export const HelpContainer = styled.div`
  margin-top: 4rem;

  h1 {
    margin-bottom: 0.3rem;
  }

  h2 {
    font-size: 1.8rem;
    color: var(--white-5);
  }

  p {
    margin-top: 2rem;
    color: var(--grey-100);
  }
`

export const WarningBadge = styled.div`
  display: flex;
  align-self: stretch;
  border-radius: 6px;
  background-color: var(--black-300);
  border-left: 8px solid var(--orange);
  padding: 0.9rem 0.8rem;
  color: var(--white-100);
  font-family: DM Sans, sans-serif;
  margin: 2rem 0rem;
`

export const FormContainer = styled.div`
  margin: 1rem 0rem;

  button {
    width: 100%;

    margin-top: 2rem;

    &:hover {
      opacity: 0.7;
    }
  }
`

